import { render, staticRenderFns } from "./personaje-icon.vue?vue&type=template&id=12f4feef&scoped=true&"
import script from "./personaje-icon.vue?vue&type=script&lang=js&"
export * from "./personaje-icon.vue?vue&type=script&lang=js&"
import style0 from "./personaje-icon.vue?vue&type=style&index=0&id=12f4feef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4feef",
  null
  
)

export default component.exports